<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@for (notification of notifications; track notification) {
  <profile-pds-p-banner p-banner [open]="notification.open ?? true" [state]="bannerState(notification)" (dismiss)="onDismiss(notification)">
    <span>{{ notification.translatedString }}</span>
  </profile-pds-p-banner>
}
